<script>
import appConfig from "@/app.config";

export default {
  layout: "auth",
  page: {
    title: "Erro 403",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Error 403",
    };
  }
};
</script>

<template>
  <div class="my-5 pt-sm-5">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <div>
              <div class="row justify-content-center">
                <div class="col-sm-4">
                  <div class="error-img">
                    <img
                      src="@/assets/images/403-error.png"
                      alt
                      class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4 class="text-uppercase mt-4">Desculpe, você não acesso à essa informação</h4>
            <p class="text-muted">
              Você não possui permissão para acessar a informação requisitada. Se você achar que há um erro, contate o administrador do sistema para revisar suas permissões de acesso.
            </p>
            <div class="mt-5">
              <router-link to="/" class="btn btn-primary"
                >Voltar a tela inicial</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
